import { makeStyles } from '@material-ui/core/styles';
import { MdCancel } from 'react-icons/md';
import { Button } from '@material-ui/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    top: 0,
    display: "flex",
    flexFlow: "column",
    width: "350px",
    minWidth: "350px",
    height: "100%",
    background: "#eee",
    zIndex: 1,
    padding: "20px",
    boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.75)",
    borderTopLeftRadius: "5%",
    borderBottomLeftRadius: "5%",

    '& #panelContent': {
      flex: "1 1 auto",
      display: "flex",
      flexFlow: "column",
      position: "relative"
    },
    '& .panel-header': {
      display: "flex",
      justifyContent: "space-between"
    },
    '& .orders-container': {
      display: "flex",
      flexDirection: "column",
      marginTop: "10px",
      maxHeight: "475px",
      overflowY: "auto"
    },
    '& .order-item': {
      background: "#fff",
      padding: "10px",
      marginTop: "10px",
      cursor: "pointer",
      borderRadius: "4px"
    },
    '& .order-item:hover': {
      border: "2px solid #cccccc",
    },
    '& .order-item.selected': {
      border: "2px solid #689f38",
    },
    '& .order-panel-action': {
      position: "absolute",
      bottom: 0,
      left: 0
    },
  }
}));

function CollectOrdersPanel(props) {
  const classes = useStyles();
  const [SelectedOrder, setSelectedOrder]: [any, any] = useState(null);
  const { t } = useTranslation();

  return (
    <div id="collectOrdersPanel" className={classes.root} style={{ right: props.showPanel ? 0 : -350 }}>
      <div id="panelContent">
        <div className="panel-header">
          <h2>{t('storereplenishmentscreen.collect-orders')}</h2>
          <div className="pointer" id="closeCollectOrdersPanel" onClick={() => props.closePanel()}><MdCancel size={32} /></div>
        </div>
        <div className="orders-container">
          {props.collectOrders.map(order => {
            return (
              <div
                key={order.Id}
                className={`order-item ${SelectedOrder && SelectedOrder.Id === order.Id ? "selected" : ""}`}
                onClick={() => setSelectedOrder(order)}
              >
                <p style={{ fontWeight: 700, marginBottom: 0 }}>{order.OrderNumber}</p>
                <p style={{ margin: 0 }}>{order.Title}</p>
              </div>
            );
          })}
        </div>

        <div className="order-panel-action">
          <Button
            id="switchOrderBtn"
            type="button"
            variant="contained"
            className="green-btn"
            disabled={!SelectedOrder}
            onClick={() => props.switchOrders(SelectedOrder)}
          >
            {t('storereplenishmentscreen.collect-orders')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default CollectOrdersPanel
